import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  HEADING: `${cleanedFilename(__filename)}-heading`,
};
